import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import DeleteIcon from '@mui/icons-material/Delete'

import { IconButton } from '../common/Button'
import { theme } from '../../themes/theme'
import { getFileSize } from '../../util/strings'
import { MedBodyText } from '../styles/Text'
import { openInNewTab } from '../../util/downloadFile'

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

const FileInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: ${props => (props.spacing === 'minimal' ? '5px 20px' : '15px 15px')};

  cursor: pointer;
  :hover {
    background: ${theme.colors.primaryLight};
    border-radius: ${props => (props.spacing === 'minimal' ? '0' : theme.borderRadius.div)};
  }

  @media only screen and (max-width: 800px) {
    flex-wrap: wrap;
    gap: 5px;
  }
`

const Filename = styled(MedBodyText)`
  font-weight: 500;
  text-wrap: wrap;
  word-break: break-word;

  @media only screen and (max-width: 800px) {
    width: 100%;
  }
`

const SizeDateText = styled(MedBodyText)`
  font-weight: 500;

  @media only screen and (max-width: 800px) {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    width: 100%;
  }
`

function BrowserFile({ file, onDelete = () => {}, loading = false, showButton = true, spacing = 'default' }) {
  const handleClick = file => openInNewTab(file, file.name)

  return (
    <Row>
      <FileInfo onClick={() => handleClick(file)} spacing={spacing}>
        <Filename>{file.name}</Filename>
        <SizeDateText>{getFileSize(file.size)}</SizeDateText>
      </FileInfo>
      {showButton && (
        <IconButton onClick={onDelete} aria-label="Delete file" disabled={loading}>
          <DeleteIcon />
        </IconButton>
      )}
    </Row>
  )
}

BrowserFile.propTypes = {
  file: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  loading: PropTypes.bool,
  showButton: PropTypes.bool,
  spacing: PropTypes.oneOf(['default', 'minimal'])
}

export default BrowserFile
